import { render, staticRenderFns } from "./DOMC.vue?vue&type=template&id=fcdcd74a&scoped=true&"
import script from "./DOMC.vue?vue&type=script&lang=js&"
export * from "./DOMC.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcdcd74a",
  null
  
)

export default component.exports